import React from "react";
import { usePublicConfig } from "./PublicConfigProvider";
import { formatSessionDateRange, isLateDeadline } from "../config";
import { useApplication } from "./ApplicationProvider";

// Round 47 — served by shared/src/server/guide.ts; same-origin, so each
// portal links to its own program's guide.
export const GUIDE_HREF = "/guide";

export function Header() {
  const cfg = usePublicConfig();
  const { isAmendmentMode, data } = useApplication();
  const dateRange = formatSessionDateRange(cfg.sessionStartDate, cfg.sessionEndDate);
  const late = isLateDeadline(cfg.applicationDeadline);
  const deadlineHuman = new Date(cfg.applicationDeadline).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <header className="bg-program text-white">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="flex items-center gap-4">
          <div className="w-28 h-28 shrink-0 bg-white rounded-full flex items-center justify-center">
            <img
              src={`/branding/${cfg.program === "boys" ? "mdbs" : "mdgs"}-logo.png`}
              alt={`${cfg.programName} logo`}
              className="w-[68%] h-[68%] object-contain"
            />
          </div>
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">{cfg.programName}</h1>
            <p className="text-sm opacity-90">Session: {dateRange}</p>
            <p className="text-xs opacity-80">
              For final details, visit{" "}
              <a className="underline" href={cfg.programInfoUrl} target="_blank" rel="noreferrer">
                {cfg.programInfoUrl.replace(/^https?:\/\//, "")}
              </a>
            </p>
            {/* Round 47 — reachable from every step (Step 3 and Step 5 are where
                families get stuck). Absent entirely while GUIDE_LINK_ENABLED is off. */}
            {cfg.guideLinkEnabled && (
              <p className="text-xs opacity-80 mt-0.5">
                <a className="underline" href={GUIDE_HREF} target="_blank" rel="noopener">
                  Application Guide
                </a>
              </p>
            )}
          </div>
        </div>
      </div>
      {late && !isAmendmentMode && (
        <div className="bg-yellow-300 text-yellow-900">
          <div className="max-w-4xl mx-auto px-4 py-2 text-sm">
            <strong>Note:</strong> The standard deadline for this session has passed (
            {deadlineHuman}). Late applications are still being accepted but may be subject to
            availability — please contact{" "}
            <a className="underline" href={`mailto:${cfg.supportEmail}`}>
              {cfg.supportEmail}
            </a>{" "}
            with any questions.
          </div>
        </div>
      )}
      {isAmendmentMode && data.meta.referenceNumber && (
        <div className="bg-blue-200 text-blue-900">
          <div className="max-w-4xl mx-auto px-4 py-2 text-sm">
            You are amending application <strong>{data.meta.referenceNumber}</strong>
            {data.meta.submittedAt && (
              <>
                , submitted{" "}
                {new Date(data.meta.submittedAt).toLocaleDateString(undefined, {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </>
            )}
            . Click <strong>Resubmit</strong> on the final step to save your changes.
          </div>
        </div>
      )}
    </header>
  );
}
